import React from "react";
import NoteEditorDrawer from "../NoteEditorDrawer";
import {
  useAddRelationshipRecordedNote,
  useUpdateRelationshipRecordedNote,
} from "../../hooks/useAccountRelationship";

const TakeNoteDrawer = ({
  isOpen,
  onClose,
  relationshipMappingId,
  noteToEdit = null,
}) => {
  const { mutate: addNote, isPending: isAdding } =
    useAddRelationshipRecordedNote({ action: onClose });
  const { mutate: updateNote, isPending: isUpdating } =
    useUpdateRelationshipRecordedNote({ action: onClose });

  const handleSave = (note) => {
    if (noteToEdit) {
      updateNote({
        noteId: noteToEdit.id,
        note,
        relationshipMappingId,
      });
      return;
    }
    addNote({ relationshipMappingId, note });
  };

  return (
    <NoteEditorDrawer
      isOpen={isOpen}
      onClose={onClose}
      noteToEdit={noteToEdit}
      isSaving={isAdding || isUpdating}
      onSave={handleSave}
    />
  );
};

export default TakeNoteDrawer;
